import { CONST_NOTIFY } from '@/services/notify/CONST';
import useQuasar from 'quasar/src/composables/use-quasar.js';;

export const notify = {
  setup() {
    return {
      $q: useQuasar(),
    };
  },
  methods: {
    toastMessage(msg, msgType = CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, options = {}) {
      const agentNumber = options.effectedAgentsNumber;
      const opts = {
        message: options.effectedAgentsNumber > 1 ? `${msg} (${agentNumber} agents were affected)` : msg,
        badgeStyle: 'opacity: 0',
        position: options && options.position ? options.position : 'top',
        classes: 'notify-box',
        timeout: options && (options.timeout || options.timeout === 0) ? options.timeout : 5000,
        actions: [{ icon: 'close', attrs: { 'aria-label': 'Dismiss' } }],
      };
      if (options && options.removeActions) delete opts.actions;

      if (msgType) {
        switch (msgType) {
          case CONST_NOTIFY.MESSAGE_TYPE.WARNING:
            opts.classes += ' notify-box-warning notify-box-dark';
            opts.icon = 'icon-Warnnig_notification_filled';
            break;
          case CONST_NOTIFY.MESSAGE_TYPE.ERROR:
            opts.classes += ' notify-box-strong notify-box-dark';
            opts.icon = 'icon-Error_notification_filled';
            break;
          case CONST_NOTIFY.MESSAGE_TYPE.SUCCESS:
          default:
            opts.classes += ' notify-box-good notify-box-dark';
            opts.icon = 'icon-Approval_notification_filled';
            break;
        }
      }
      if (options.icon) opts.icon = options.icon;

      return this.$q.notify(opts);
    },
  },
};

export const useNotify = () => {
  const $q = useQuasar();
  const toastMessage = (msg, msgType = CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, options = {}) => {
    const agentNumber = options.effectedAgentsNumber;
    const opts = {
      message: options.effectedAgentsNumber > 1 ? `${msg} (${agentNumber} agents were affected)` : msg,
      badgeStyle: 'opacity: 0;',
      position: options && options.position ? options.position : 'top',
      classes: 'notify-box',
      timeout: options && (options.timeout || options.timeout === 0) ? options.timeout : 5000,
      actions: [{ icon: 'close', attrs: { 'aria-label': 'Dismiss' } }],
    };
    if (options && options.removeActions) delete opts.actions;

    if (msgType) {
      switch (msgType) {
        case CONST_NOTIFY.MESSAGE_TYPE.WARNING:
          opts.classes += ' notify-box-warning notify-box-dark';
          opts.icon = 'icon-Warnnig_notification_filled';
          break;
        case CONST_NOTIFY.MESSAGE_TYPE.ERROR:
          opts.classes += ' notify-box-strong notify-box-dark';
          opts.icon = 'icon-Error_notification_filled';
          break;
        case CONST_NOTIFY.MESSAGE_TYPE.SUCCESS:
        default:
          opts.classes += ' notify-box-good notify-box-dark';
          opts.icon = 'icon-Approval_notification_filled';
          break;
      }
    }
    if (options.icon) opts.icon = options.icon;

    return $q.notify(opts);
  };
  return { toastMessage };
};
